import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gc-test',
  template: `<p>Hello world</p>`,
  styles: [
  ]
})
export class GacoiLibComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
